export default __webpack_public_path__ + "static/media/Vanguard.bb00bd17.jpg";